import PropTypes from 'prop-types';

// material-ui
import Box from '@mui/material/Box';

// project imports
import SidebarModeSwitch from './SidebarModeSwitch';

// ==============================|| DRAWER FOOTER ||============================== //
// Patička sidebaru (2026-08-23, na přání uživatele) - drží se dole pod
// navigací (viz Drawer/index.jsx's mt: 'auto' na .MuiDrawer-paper flex
// sloupci), stejný princip jako patička s theme přepínačem v Profile
// panelu, jen pro chování sidebaru (auto/uživatel), ne barevné schéma.

export default function DrawerFooter({ open }) {
  return (
    <Box sx={{ mt: 'auto', py: 1.5, px: open ? 2.5 : 0, borderTop: 1, borderColor: 'divider' }}>
      <SidebarModeSwitch open={open} />
    </Box>
  );
}

DrawerFooter.propTypes = { open: PropTypes.bool };
